const environment = {
    api: process.env.REACT_APP_API_URL,
    chat_api: process.env.REACT_APP_API_URL,
    userRoleId: process.env.REACT_APP_USER_ROLE_ID,
    adminRoleId: process.env.REACT_APP_ADMIN_ROLE_ID,
    staffRoleId:process.env.REACT_APP_STAFF_ROLE_ID,
    contactRoleId:process.env.REACT_APP_CONTACT_ROLE_ID,
    supplierRoleId:process.env.REACT_APP_SUPPLIER_ROLE_ID,
    map_api_key: process.env.REACT_APP_MAP_API_KEY,
    secretKey:process.env.REACT_APP_CRYPTO_SECRET_KEY,
    kanataKey:process.env.REACT_APP_KANATA_ID,
    craftKey:process.env.REACT_APP_CRAFT_ID,
    tx450key:process.env.REACT_APP_TX450_ID,
    tx450_20key:process.env.REACT_APP_TX450_20_ID,
    tx500key:process.env.REACT_APP_TX500_ID,
    tx500_20key:process.env.REACT_APP_TX500_20_ID,
    tx380key:process.env.REACT_APP_TX380_ID,

  };

  export default environment;